import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class PayService {

  constructor(private http: HttpClient) {}

   getPayData(userSession: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    return this.http.get(
      `${ApiConfig.baseUrl}/Pay/get-pay-data`,
      { headers }
    );
  }
  postPay(userSession: string, 
          authorizationPin: string, 
          payMethodId: string, 
          beneficiaryId: string,
          newBeneficiaryName: string,
          newBeneficiaryNumber: string,
          newBeneficiaryDisplayNumber: string,
          serviceFeeId: string,
          bankAccountId: string,
          bankId: string,
          accountNumber: string,
          amount: number, 
          serviceFee: number, 
          totalAmount: number): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      authorizationPin,
      payMethodId,
      beneficiaryId,
      serviceFeeId,
      newBeneficiaryName,
      newBeneficiaryNumber,
      newBeneficiaryDisplayNumber,
      bankAccountId,
      bankId,
      accountNumber,
      amount,
      serviceFee,
      totalAmount
    };
    return this.http.post(
    `${ApiConfig.baseUrl}/pay/pay`,
    request,
    {
        headers,
        observe: 'response'
    }
    );
  }
}